import { Injectable, Provider } from '@angular/core';

@Injectable()
export class RouterTransitionsService {
  public onSuccess(filter: any, callback: (transition: any) => void) { }
}

export function RouterTransitionsServiceFactory(i: any) {
  return i.get('$transitions');
}

export const RouteTransitionsServiceProvider: Provider = {
  provide: RouterTransitionsService,
  useFactory: RouterTransitionsServiceFactory,
  deps: ['$injector'],
};
